import { SELECTED_ITEMS, UPDATE_CATEGORY, UPDATE_MENUS, UPDATE_CART, UPDATE_DAYSOFWEEK, UPDATE_ORDER_TOTALCOST, UPDATE_VIEW_CART, UPDATE_WEEKLY_BOOKING, UPDATE_KIOSK, UPDATE_CAFETERIA_ID, UPDATE_VENDOR_ID, TODAY_ORDER_LIST, ACTIVE_CUTOFF_LUNCH } from "../../actionTypes/user";
import { UPDATE_LOGIN } from "../../actionTypes/profile";
import { OVERALL_CAFETERIA_ID } from "../../../utils/constants";

// The vendor picked after login survives a page reload, not a logout
const storedVendorId = () => {
  try {
    const id = sessionStorage.getItem('vendorId');
    return id ? +id : null;
  } catch (e) {
    return null;
  }
};

const intialState = {
  selectedItems: [],
  categoryList: [],
  mealMenuList: [],
  cartList: [],
  daysOfWeek: [],
  getOrderTotalCost: [],
  viewCartList: [],
  weeklyBookingDates: [],
  kiosk: [],
  cafeteriaId: OVERALL_CAFETERIA_ID,
  vendorId: storedVendorId(),
  todayOrderDate: [],
  activeCutoffLunch: []
};

export default function UserHomeReducers(state = intialState, action) {
  switch (action.type) {

    case SELECTED_ITEMS:
      return { ...state, selectedItems: action.payload };

    case UPDATE_CATEGORY:
      return { ...state, categoryList: action.payload };

    case UPDATE_MENUS:
      return { ...state, mealMenuList: action.payload };

    case UPDATE_CART:
      return { ...state, cartList: action.payload };

    case UPDATE_DAYSOFWEEK:
      return { ...state, daysOfWeek: action.payload };

    case UPDATE_ORDER_TOTALCOST:
      return { ...state, getOrderTotalCost: action.payload };

    case UPDATE_VIEW_CART:
      return { ...state, viewCartList: action.payload };

    case UPDATE_WEEKLY_BOOKING:
      return { ...state, weeklyBookingDates: action.payload };

    case UPDATE_KIOSK:
      return { ...state, kiosk: action.payload };

    case UPDATE_CAFETERIA_ID:
      return { ...state, cafeteriaId: action.payload };

    case UPDATE_VENDOR_ID:
      return { ...state, vendorId: action.payload };

    case TODAY_ORDER_LIST:
      return { ...state, todayOrderDate: action.payload };

    case ACTIVE_CUTOFF_LUNCH:
      return { ...state, activeCutoffLunch: action.payload };

    case UPDATE_LOGIN:
      return (action.payload && action.payload.length)
        ? state
        : { ...state, cafeteriaId: OVERALL_CAFETERIA_ID, vendorId: null };

    default:
      return state;
  }
}
